import mod from "-!./AdminSvg.js?vue&type=script&lang=js&"; export default mod; export * from "-!./AdminSvg.js?vue&type=script&lang=js&"